export default "__VITE_ASSET__sd4M8CyO__"